export const T = {
  en_GB: {
    advisorCannotAccess:
      "Advisors cannot access public client links. Please sign out from the advisor dashboard first.",
    verifyYourIdentity: "Verify Your Identity",
    signInAsRepresentative: (name: string) => `Sign in as ${name}`,
    representativeNote: (name: string) =>
      `This link is personal to ${name} — only they may use it to sign in on the client's behalf.`,
    enterCodeToContinue: "Enter the verification code to continue",
    sendVerificationCode: "We'll send you a verification code to authenticate",
    chooseMethod: "Choose how you'd like to receive your verification code",
    sendCodeViaEmail: "Send Code via Email",
    sendCodeViaSMS: "Send Code via SMS",
    orSignInWith: "Or sign in with",
    bankIdMitId: "BankID / MitID",
    secureAuth: "Secure authentication using your national eID",
    authFailed: "Authentication failed",
    failedToSendCode: "Failed to send verification code",
    codeSentEmail: "Verification code sent via email!",
    codeSentSMS: "Verification code sent via SMS!",
    identityMismatch: (name: string) => `This link belongs to ${name}. Sign in with their BankID.`,
    useMemberLinks:
      "Several people answer for this client, each with their own personal link. Ask your advisor for yours.",
    identityMismatchGeneric:
      "This link belongs to another person. Please sign in with their BankID.",
    tryAgain: "Try again",
    // Unavailable-link reasons (PublicLinkUnavailableReason) — kept word-for-word
    // in sync with `/p/error` and the member link page.
    linkExpired: "This link has expired. Ask your advisor for a new one.",
    linkRevoked: "This link has been withdrawn by your advisor.",
    representativeRemoved:
      "This link was issued to a representative who is no longer registered for this client. Contact your advisor.",
    representativeChanged:
      "Who signs in for this client has changed, so this link no longer works. Ask your advisor for a new one.",
    memberRemoved:
      "This link was issued to a member who is no longer part of this group. Contact your advisor.",
    linkNotFound: "This link is not valid.",
  },
  nb_NO: {
    advisorCannotAccess:
      "Rådgivere kan ikke få tilgang til offentlige kundelenker. Vennligst logg ut fra rådgiverpanelet først.",
    verifyYourIdentity: "Bekreft din identitet",
    signInAsRepresentative: (name: string) => `Logg inn som ${name}`,
    representativeNote: (name: string) =>
      `Denne lenken er personlig for ${name} — bare de kan bruke den til å logge inn på vegne av kunden.`,
    enterCodeToContinue: "Skriv inn verifiseringskoden for å fortsette",
    sendVerificationCode: "Vi sender deg en verifiseringskode for å autentisere",
    chooseMethod: "Velg hvordan du vil motta verifiseringskoden",
    sendCodeViaEmail: "Send kode via e-post",
    sendCodeViaSMS: "Send kode via SMS",
    orSignInWith: "Eller logg inn med",
    bankIdMitId: "BankID / MitID",
    secureAuth: "Sikker autentisering med nasjonal eID",
    authFailed: "Autentisering mislyktes",
    failedToSendCode: "Kunne ikke sende verifiseringskode",
    codeSentEmail: "Verifiseringskode sendt via e-post!",
    codeSentSMS: "Verifiseringskode sendt via SMS!",
    identityMismatch: (name: string) => `Denne lenken tilhører ${name}. Logg inn med deres BankID.`,
    identityMismatchGeneric: "Denne lenken tilhører en annen person. Logg inn med deres BankID.",
    useMemberLinks:
      "Flere personer svarer for denne kunden, hver med sin egen personlige lenke. Be rådgiveren din om din.",
    tryAgain: "Prøv igjen",
    linkExpired: "Denne lenken har utløpt. Be rådgiveren din om en ny.",
    linkRevoked: "Denne lenken er trukket tilbake av rådgiveren din.",
    representativeRemoved:
      "Denne lenken ble utstedt til en representant som ikke lenger er registrert for denne kunden. Kontakt rådgiveren din.",
    representativeChanged:
      "Den som skal logge inn for denne klienten er endret, så denne lenken virker ikke lenger. Be rådgiveren din om en ny.",
    memberRemoved:
      "Denne lenken ble utstedt til et medlem som ikke lenger er en del av denne gruppen. Kontakt rådgiveren din.",
    linkNotFound: "Denne lenken er ikke gyldig.",
  },
} as const;
